import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Paper,
  Typography,
  Divider,
} from '@mui/material';
import {
  Search as SearchIcon,
  Clear as ClearIcon,
  FilterList as FilterIcon,
} from '@mui/icons-material';

interface Firm {
  id: number;
  name: string;
  type: string;
}

interface Role {
  value: string;
  label: string;
}

interface MasqueradeFiltersProps {
  searchTerm: string;
  selectedRole: string;
  selectedFirm: string;
  firms: Firm[];
  roles: Role[];
  onSearchChange: (value: string) => void;
  onRoleChange: (value: string) => void;
  onFirmChange: (value: string) => void;
  onSearch: (e: React.FormEvent) => void;
  onClearFilters: () => void;
}

const MasqueradeFilters: React.FC<MasqueradeFiltersProps> = ({
  searchTerm,
  selectedRole,
  selectedFirm,
  firms,
  roles,
  onSearchChange,
  onRoleChange,
  onFirmChange,
  onSearch,
  onClearFilters
}) => {
  return (
    <Paper elevation={1} sx={{ bgcolor: 'grey.50' }}>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <FilterIcon color="primary" sx={{ mr: 1 }} />
          <Typography variant="h6" component="h2">
            Filter Users
          </Typography>
        </Box>
        
        <form onSubmit={onSearch}>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' }, gap: 3 }}>
            <Box>
              <TextField
                fullWidth
                label="Search Users"
                placeholder="Search by name or email..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                InputProps={{
                  startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
                }}
                variant="outlined"
                size="small"
              />
            </Box>
            
            <Box>
              <FormControl fullWidth size="small">
                <InputLabel>Role</InputLabel>
                <Select
                  value={selectedRole}
                  label="Role"
                  onChange={(e) => onRoleChange(e.target.value)}
                >
                  {roles.map(role => (
                    <MenuItem key={role.value} value={role.value}>
                      {role.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            
            <Box>
              <FormControl fullWidth size="small">
                <InputLabel>Firm</InputLabel>
                <Select
                  value={selectedFirm}
                  label="Firm"
                  onChange={(e) => onFirmChange(e.target.value)}
                >
                  <MenuItem value="">All Firms</MenuItem>
                  {firms.map(firm => (
                    <MenuItem key={firm.id} value={firm.id}>
                      {firm.name} ({firm.type})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            
            <Box sx={{ display: 'flex', gap: 1, height: '100%', alignItems: 'flex-end' }}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SearchIcon />}
                fullWidth
                sx={{ height: 40 }}
              >
                Search
              </Button>
              <Button
                type="button"
                variant="outlined"
                startIcon={<ClearIcon />}
                onClick={onClearFilters}
                sx={{ height: 40 }}
              >
                Clear
              </Button>
            </Box>
          </Box>
        </form>
      </Box>
    </Paper>
  );
};

export default MasqueradeFilters;
